module.exports = __webpack_public_path__ + "static/media/download-sq.028dca79.svg";